/**
 * OVERRIDE ContactForm.jsx
 */

import DefaultContactFormComponent from '../../../../components/Contact/DefaultContactForm';

export default DefaultContactFormComponent;